// import Vue from "vue"
// import router from "@/router"
import { make } from "vuex-pathify"
// import { Toast } from "buefy/dist/components/toast"
import ContractTypeProxy from "@/proxies/ContractTypeProxy"

const state = {
  contractTypes: [],
  contractType: {}
}

const mutations = make.mutations(state)

const actions = {
  async all({ commit }, params = {}) {
    let response = await new ContractTypeProxy(params).all()
    commit("SET_CONTRACT_TYPES", response)
  },

  async find({ commit }, id, params = {}) {
    let response = await new ContractTypeProxy(params).find(id)
    commit("SET_CONTRACT_TYPE", response)
  },

  async create(_, item) {
    return await new ContractTypeProxy().create(item)
  },

  async update({ dispatch }, { id, data, params = {} }) {
    let response = await new ContractTypeProxy(params).update(id, data)
    await dispatch("find", id)
    return response
  },

  async destroy(_, id, params = {}) {
    return await new ContractTypeProxy(params).destroy(id)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
